export const LAUNCHPAD_ROUTE = 'launchpad';
export const LAUNCHPAD_ROOT_PATH = `${window.location.origin}/${LAUNCHPAD_ROUTE}`;
export const NO_ACCESS_ROUTE = 'no-access';
export const NO_ACCESS_PAGE = `${window.location.origin}/${NO_ACCESS_ROUTE}`;
export const NO_ACCESS_RETURN_URL_PARAM = 'return-url';
